module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/Desktop/sailing-work/mapbox/mapboxProject/node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/object/assign.js
// module id = aA9S
// module chunks = 1